import {useEffect, RefObject} from 'react';

const useOnOutsideClick = (
    isTrue: boolean,
    ref: RefObject<HTMLElement>,
    action: () => void,
    dependencies?: unknown
) => {
  useEffect(() => {
    const checkIfClickedOutside = async (e) => {
      if (isTrue && ref.current && !ref.current.contains(e.target)) {
        action();
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [ref, JSON.stringify(dependencies)]);
};

export default useOnOutsideClick;
